import { SiteSelectionDropdownConfig } from "@/cpm/models/site-entity.model";

export const singlesiteSelectionDropdownConfig: SiteSelectionDropdownConfig = {
    displayKey: 'dis',
    groupedKey: 'organization',
    valueKey: 'id',
    placeholder: 'Select Site',
    searchPlaceholder: 'Search for Organization/Site/Address',
    siteSelection: true,
    multiSelect: false
};

export const OrgSelectionConfig: SiteSelectionDropdownConfig = {
    displayKey: 'name',
    valueKey: 'orgId',
    placeholder: 'Select Organization',
    searchPlaceholder: 'Search for Organizations',
    siteSelection: false,
    multiSelect: false,
    orgSelection: true,
    dateTimeKey: 'createdAt'
}